const BookSuccessModal = ({ bookSuccessModalRef }) => {
  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={bookSuccessModalRef} id="modalBookSuccess" tabIndex="-1" aria-labelledby="modalBookSuccessTitle" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalBookSuccessTitle">Thank You!</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
            We've received your details and our team will contact you shortly to guide you through the next steps. Get ready to turn your travel plans into reality!
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BookSuccessModal